/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_DescriptionInputs */

const en_settings_profile_description = /** @type {(inputs: Settings_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your account`)
};

const zh_settings_profile_description = /** @type {(inputs: Settings_Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理你的账户`)
};

/**
* | output |
* | --- |
* | "Manage your account" |
*
* @param {Settings_Profile_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_description = /** @type {((inputs?: Settings_Profile_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_description(inputs)
	return zh_settings_profile_description(inputs)
});
export { settings_profile_description as "settings.profile.description" }